import CardsApi from '../api/CardsApi';
import CardsConstants from '../constants/CardsConstants';

export function searchCards({ metadataIds, searchType, query, limit, ...filters }) {
  return {
    types: [
      CardsConstants.SEARCH_CARDS_REQUEST,
      CardsConstants.SEARCH_CARDS_SUCCESS,
      CardsConstants.SEARCH_CARDS_FAILURE
    ],
    apiRequest: (state, apiClient) =>
      CardsApi.searchCards(
        {
          metadataIds,
          searchType,
          query,
          limit,
          ...filters
        },
        apiClient
      )
  };
}

export default {
  searchCards
};
